import { createTheme } from "../../helpers/create-theme";
import type { ActionButtonTheme } from "./base-action-button";

// Sizing is intentionally minimal here — branded-action-button applies
// brand-driven height + padding via arbitrary CSS-property utility classes
// (e.g. brand-button-sizing reading the --brand-button-* vars) on the element. Keeping shared layout (px-[24px], items-center,
// w-full self-stretch) so consumers without a wrapper still render sensibly.
export const defaultTheme: ActionButtonTheme = createTheme({
  root: {
    base: "border items-center px-[24px] w-full self-stretch",
    children:
      "text-center text-[15px] font-medium leading-[22px] tracking-[1.5px]",
  },
});
